"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMap = void 0;
function createMap(fn) {
    function result(mappingOrLess, equal, greater) {
        if (arguments.length > 1) {
            return fn(mappingOrLess, equal, greater);
        }
        const mapping = mappingOrLess;
        return fn(mapping.less, mapping.equal, mapping.greater);
    }
    return result;
}
exports.createMap = createMap;
